import { styled } from "@mui/material/styles";
import TableRow, { tableRowClasses } from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "#e0dedc",
  },
  "&:nth-of-type(odd)": {
    //   backgroundColor: "#F7FBFF",
  },
  // hide last border
  "&:last-child td": {
    // border: 0,
    // borderBottom: "2px solid #00AEEF",
  },
  [`&.${tableRowClasses.root}.grid td`]: {
    borderRight: "1px solid #d6d6d6",

  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#fff",
    color: "#000",
    padding: "10px 10px",
    fontSize: "14px",
    fontWeight: 600,
  },
  [`&.${tableCellClasses.head}:first-of-type`]: {
    borderLeft: "2px solid #00AEEF",
    padding: "10px 16px",
  },
  [`&.${tableCellClasses.head}:last-child`]: {
    // borderRight: 0,
    borderRight: "2px solid #00AEEF",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#444",
    // fontWeight: "500",
    borderRight: 0,
    // borderBottom: "1px solid #d6d6d6",
    padding: "10px 10px",
  },
  [`&.${tableCellClasses.body}:first-of-type`]: {
    padding: "10px 10px 10px 5px",
    // borderBottom: "2px solid #00AEEF",
    // borderBottom: 0,
  },
  [`&.${tableCellClasses.body}:last-child`]: {
    borderRight: 0,
    // borderBottom: "2px solid #00AEEF",
    // borderBottom: 0,
  },
}));